export default "__VITE_ASSET__BKlJ1xI2__"